import PropTypes from 'prop-types'
import React from 'react'
import { get, isEmpty } from 'lodash-es'
import { FormattedMessage } from 'react-intl'

import SpeakersFeature from '../../features/SpeakersFeature'
import {
  IconComponent,
  LoaderWrapperComponent,
  ReadMoreComponent,
  RichTextComponent,
} from '..'
import { useWebinarColors } from '../../hooks/useWebinarColors'

import './WebinarInfoPanelComponent.scss'

const WebinarInfoPanelComponent = (props) => {
  const {
    liveData,
    onSpeakersInit,
    speakersSize,
    theme = 'no',
    isShowingSpeakers,
  } = props

  const webinarColors = useWebinarColors()

  if (!liveData) return null

  return (
    <div className={`webinar-info-panel-component ${theme}-theme`}>
      <LoaderWrapperComponent loading={isEmpty(liveData)}>
        <h3>{get(liveData, 'name')}</h3>

        <div className="webinar-date">
          {theme === 'waiting-room' && (
            <IconComponent name="date" color="8d8e8d" className="date-icon" />
          )}
          {get(liveData, 'primary_timezone_live_date__date')} &nbsp;
          {get(liveData, 'primary_timezone_live_date__time')} <br />
        </div>

        <ReadMoreComponent lines={3}>
          <RichTextComponent text={get(liveData, 'description_html')} />
        </ReadMoreComponent>

        {isShowingSpeakers && (
          <>
            <h4
              className="section-title"
              style={{ color: webinarColors.tabs.contrast.transparent('85%') }}
            >
              <FormattedMessage defaultMessage="Speakers" />
            </h4>

            <SpeakersFeature
              namespace="info-panel-speakers"
              listType="compact"
              featureProps={{
                liveId: get(liveData, 'live_id'),
                token: get(liveData, 'token'),
                isExcludingHidden: true,
              }}
              styles={{
                loaderStyles: {
                  background: 'transparent',
                  opacity: 0.05,
                },
                textStyles: { color: webinarColors.tabs.highContrast.color },
              }}
              onSpeakersInit={onSpeakersInit}
              size={speakersSize}
              renderIfEmpty={false}
            />
          </>
        )}
      </LoaderWrapperComponent>
    </div>
  )
}

WebinarInfoPanelComponent.propTypes = {
  liveData: PropTypes.object,
  onSpeakersInit: PropTypes.func,
  theme: PropTypes.oneOf(['waiting-room']),
  speakersSize: PropTypes.oneOf(['large', 'small']),
  isShowingSpeakers: PropTypes.bool,
}

WebinarInfoPanelComponent.defaultProps = {
  speakersSize: 'small',
}

export default WebinarInfoPanelComponent
